export const environment = {
  production: false,
  apiBaseUrl: 'https://index-core-task-api.isbe.out.nakamenosakura.com/api',
  fileSystemApiUrl: 'http://index-core-api.isbe.in.nakamenosakura.com/api/fileSystem',
  convertApiUrl: 'http://index-core-convert-api.isbe.in.nakamenosakura.com/api',
  taskFileId: 'convert-demo-json-to-json',
  bucketCode: 'x93jkd8f-qpz1-mv8w',
  bucketCodeMapping: 'biz-marche-convert-management',
};

